import axios from "axios";
import { showAlert } from "./alert";

//
export const createItem = async (itemNumber, itemDescription, usersPrice) => {
  try {
    const res = await axios({
      method: "POST",
      url: "/api/v1/items",
      data: {
        itemNumber,
        itemDescription,
        usersPrice,
      },
    });

    if (res.data.status === "success") {
      showAlert("success", `Upload successful!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
    next();
  }
};

export const editItem = async (itemNumber, usersPrice) => {
  try {
    const res = await axios({
      method: "PATCH",
      url: `/api/v1/items/${itemNumber}`,
      data: {
        itemNumber,
        usersPrice,
      },
    });

    if (res.data.status === "success") {
      showAlert("success", `Upload successful!`);
      window.setTimeout(() => {
        location.reload();
      }, 1000);
    }
  } catch (err) {
    showAlert("error", err.response.data.message);
    next();
  }
};

export const deleteItem = async (itemNumber) => {
  try {
    const res = await axios({
      method: "DELETE",
      url: `/api/v1/items/${itemNumber}`,
      data: {
        itemNumber,
      },
    });

    showAlert("success", `Item ${itemNumber} deleted!`);
    window.setTimeout(() => {
      location.assign("/pricing");
    }, 1000);
  } catch (err) {
    showAlert("error", err.response.data.message);
    next();
  }
};
